import { render, staticRenderFns } from "./_id.vue?vue&type=template&id=75f2fe07&scoped=true"
import script from "./_id.vue?vue&type=script&lang=js"
export * from "./_id.vue?vue&type=script&lang=js"
import style0 from "./_id.vue?vue&type=style&index=0&id=75f2fe07&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75f2fe07",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CmnHeader: require('/ntweb/components/cmn-header.vue').default,JdDetail: require('/ntweb/components/jd-detail.vue').default,JdRefereeList: require('/ntweb/components/jd-referee-list.vue').default,JdRecomList: require('/ntweb/components/jd-recom-list.vue').default,JdCompany: require('/ntweb/components/jd-company.vue').default,JdOwner: require('/ntweb/components/jd-owner.vue').default,CvSelectorList: require('/ntweb/components/cv-selector-list.vue').default,ChatRoom: require('/ntweb/components/chat-room.vue').default,CmnFooter: require('/ntweb/components/cmn-footer.vue').default})
